import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { File } from './file';
import { Proposal } from './proposal';

export class ProposalFile extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static ProposalFileProperties: (
    | {
        property: keyof ProposalFile;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof ProposalFile;
        type: 'alias';
      }
    | {
        property: keyof ProposalFile;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'ProposalId', type: 'column', dataType: 'number' },
    { property: 'FileId', type: 'column', dataType: 'number' },
    { property: 'uploadedBy', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },
    { property: 'isArchived', type: 'column', dataType: 'boolean' },

    { property: 'Proposal', model: 'Proposal', type: 'association' },
    { property: 'File', model: 'File', type: 'association' }
  ];

  static {
    ProposalFile.ProposalFileProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        ProposalFile.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        ProposalFile.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        ProposalFile.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(ProposalFileObject: Partial<ProposalFile>) {
    super();

    ProposalFile.ProposalFileProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = ProposalFileObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  ProposalId?: number;
  FileId?: number;
  uploadedBy?: 'CLIENT' | 'VENDOR';
  createdAt?: Date;
  updatedAt?: Date;
  isArchived?: boolean;

  Proposal?: Proposal;
  File?: File;
}
